import { MAX_CLIP_DURATION_SECONDS, MIN_CLIP_DURATION_SECONDS } from './ClipTrimmer';

// Footage exposed either side of the initial clip so the trim handles have room to move,
// without opening the filmstrip onto a whole multi-minute speech.
const WINDOW_PADDING_SECONDS = 20;

// Shared by the modal and the offscreen preparer so both frame the same window.
const computeClipWindow = ({ itemVideoStart, itemVideoEnd, videoDuration }) => {
  const anchorStart = Math.max(0, itemVideoStart);
  const anchorEnd = videoDuration ? Math.min(videoDuration, itemVideoEnd) : itemVideoEnd;
  const rawDuration = Math.max(0, anchorEnd - anchorStart);

  const clipStart = anchorStart;
  const clipEnd =
    anchorStart + Math.min(Math.max(rawDuration, MIN_CLIP_DURATION_SECONDS), MAX_CLIP_DURATION_SECONDS);

  const windowStart = Math.max(0, clipStart - WINDOW_PADDING_SECONDS);
  const windowEnd = videoDuration
    ? Math.min(videoDuration, clipEnd + WINDOW_PADDING_SECONDS)
    : clipEnd + WINDOW_PADDING_SECONDS;

  return { clipStart, clipEnd, windowStart, windowEnd };
};

export { computeClipWindow };
